<template>
  <div class="vacancy" @click="goToStages">
    <div class="vacancy-title">
      <p class="vacancy__name">
        {{ formatHtml(fields?.name?.text) || '[нет наименования]' | format }}
        <a
          class="vacancy-title__icon"
          @click="
            event => {
              event.stopPropagation();
              goToVacancy();
            }
          "
        >
          <Tooltip
            content="Открыть вакансию в новой вкладке"
            effect="dark"
            placement="top-start"
          >
            <Picture
              :url="fields.vacancy_link.icon ? fields.vacancy_link.icon : ''"
              width="24"
              height="24"
            />
          </Tooltip>
        </a>
      </p>
    </div>
    <p class="vacancy__custom-name">
      {{ formatHtml(fields?.custom_name?.text) || '' }}
    </p>
    <div class="stage-info">
      <a
        v-if="fields.stage_name?.intents"
        class="stage-info__name"
        @click="
          event => {
            event.stopPropagation();
            callPopup(fields.stage_name.intents);
          }
        "
        >{{
          formatHtml(fields.stage_name.text) || '[нет наименования]' | format
        }}</a
      >
      <p v-else class="stage-info__name">
        {{
          formatHtml(fields.stage_name?.text) || '[нет наименования]' | format
        }}
      </p>
      <div class="stage-info__position-info">
        <Picture
          :url="fields.position.icon ? fields.position.icon : ''"
          class="stage-info__image"
        />
        <p class="stage-info__position">
          {{ formatHtml(fields.position.text) || '' }}
        </p>
      </div>
    </div>
    <div
      v-if="fields.sla_expired || fields.sla_last_day || fields.sla_left"
      :class="[
        'step-sla',
        fields.sla_expired.text
          ? 'step-sla--red'
          : fields.sla_last_day.text
          ? 'step-sla--yellow'
          : fields.sla_left.text
          ? 'step-sla--grey'
          : ''
      ]"
    >
      {{
        fields.sla_expired.text ||
        fields.sla_last_day.text ||
        fields.sla_left.text
      }}
    </div>
    <div v-if="fields?.stage_status?.value" class="step-status">
      <p>Статус</p>
      <Tooltip
        v-if="fields?.stage_status?.value"
        :content="getOptionStatus(fields?.stage_status?.value)"
        :disabled="getOptionStatus(fields?.stage_status?.value).length < 15"
        effect="dark"
      >
        <div class="step-status__name">
          {{ getOptionStatus(fields?.stage_status?.value) || '' }}
        </div>
      </Tooltip>
    </div>
    <div class="bottom-info">
      <div class="recruiter-info">
        <Picture
          :url="fields.modified_user.icon ? fields.modified_user.icon : ''"
          class="stage-info__image"
        />
        <p class="recruiter-info__text">
          {{ formatHtml(fields.modified_user.text) || '' }}
        </p>
      </div>
      <p class="vacancy__time-work">
        {{ formatHtml(fields.time_work.text) || '' }}
      </p>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import { mixin, dialogMixin, stage } from '@/utils/mixins';
import { detailView } from '@/utils/helpers';
import Picture from 'Elements/Picture/Picture';
import Tooltip from 'Elements/Tooltip/Tooltip';

export default {
  mixins: [mixin, dialogMixin, stage],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    fields() {
      return this.item.fields.schema;
    }
  },
  methods: {
    getOptionStatus(optionId) {
      if (this.fields?.stage_status?.options?.length) {
        return (
          this.fields?.stage_status?.options.filter(
            opt => opt.id == optionId
          )[0].value || ''
        );
      } else {
        return '';
      }
    },
    callPopup(intents) {
      console.log('Вызов попапа', intents);
    },
    goToVacancy() {
      const vacancyId =
        this.item?.fields?.schema?.vacancy_link?.intents[0]?.request
          ?.request_params?.record;
      if (vacancyId) {
        let route = this.$router.resolve(`/vacancies/${vacancyId}`);
        window.open(route.href, '_blank');
      }
    },
    async goToStages() {
      store.dispatch('rightPanel/getMetadata', {
        intentOrRequest: this.item.intents.intents.request
      });
      store.commit('rightPanel/setParam', {
        name: 'panelMode',
        val: 'canditateStagePanel'
      });
    },
    viewRoute(vacancyId) {
      return detailView(this.vacancyModule, vacancyId);
    }
  },
  components: { Picture, Tooltip }
};
</script>

<style lang="scss" scoped>
.vacancy {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 8px 12px;
  background: $white;
  border: 1px solid $black-30;
  box-sizing: border-box;
  border-radius: 4px;
  width: 288px;

  &:hover {
    border: 1px solid $blue64;
    background: $blue8;
  }

  &-title {
    display: flex;
    gap: 8px;

    &__icon {
      position: absolute;
      width: 24px;
      margin-left: 4px;
    }
  }

  &__name {
    font-family: 'Roboto Medium';
    font-size: 16px;
    line-height: 24px;
    padding: 0;
    color: $grey80;
    text-decoration: none;
    width: fit-content;
    position: relative;
    margin-right: 24px;
  }

  &__custom-name {
    word-break: break-all;
  }

  &__custom-name,
  &__time-work {
    font-size: 14px;
    color: $grey64;
    line-height: 24px;
  }

  &__time-work {
    text-align: right;
  }
}

.step-sla {
  text-align: left;
  white-space: nowrap;
  width: min-content;
  border-radius: 4px;
  font-size: 14px;
  margin-top: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding: 2px 8px;

  &--yellow {
    background: $yellow;
    color: $grey80;
  }

  &--red {
    color: $white;
    background: $red;
  }

  &--grey {
    background: $grey12;
    color: $grey64;
  }
}

.step-status {
  display: flex;
  margin-top: 8px;
  text-align: left;
  gap: 8px;
  height: 24px;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $black;

  &__name {
    background: $blue40;
    color: $white;
    padding: 2px 8px;
    max-width: 120px;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.stage-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;

  &__name {
    color: $blue64;
    font-size: 14px;
    line-height: 24px;
  }

  &__image {
    filter: invert(57%) sepia(10%) saturate(567%) hue-rotate(169deg)
      brightness(90%) contrast(85%);
  }

  &__position {
    font-family: 'Roboto Medium';
    font-size: 16px;
    line-height: 24px;
    color: $grey64;

    &-info {
      display: flex;
      gap: 4px;
      align-items: center;
    }
  }
}

.bottom-info {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.recruiter-info {
  display: flex;
  gap: 4px;
  align-items: center;

  &__text {
    color: $grey80;
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
